import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getTraduccionesPagina,
  updateTraduccionPagina,
  insertTraduccionPagina,
  deleteTraduccionPagina,
  getTraduccionPaginanByTipoId,
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_TRADUCCIONES_PAGINA() {
  try {
    const traduccionesPaginaData = yield call(getTraduccionesPagina)
    if (traduccionesPaginaData.ok) {
      yield put({
        type: actions.TRADUCCIONES_PAGINA_LOAD_SUCCEEDED,
        payload: traduccionesPaginaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar traducciones página')
      put({
        type: actions.TRADUCCIONES_PAGINA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRADUCCIONES_PAGINA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_TRADUCCION_PAGINA(action) {
  try {
    const traduccionPaginaObj = yield call(insertTraduccionPagina, action.payload)
    if (traduccionPaginaObj.ok) {
      putMessage(messageType.SUCCESS, 'Traducción página creada correctamente')
      yield put({
        type: actions.TRADUCCION_PAGINA_INSERT_SUCCEEDED,
        payload: traduccionPaginaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Traducción página')
      yield put({
        type: actions.TRADUCCION_PAGINA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Traducción página')
    yield all([
      put({
        type: actions.TRADUCCION_PAGINA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_TRADUCCION_PAGINA(action) {
  try {
    const traduccionPaginaObj = yield call(updateTraduccionPagina, action.payload)
    if (traduccionPaginaObj.ok) {
      putMessage(messageType.SUCCESS, 'Traducción página modificada correctamente')
      yield put({
        type: actions.TRADUCCION_PAGINA_UPDATE_SUCCEEDED,
        payload: traduccionPaginaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Traducción página')
      yield put({
        type: actions.TRADUCCION_PAGINA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Traducción página')
    yield all([
      put({
        type: actions.TRADUCCION_PAGINA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_TRADUCCION_PAGINA(action) {
  try {
    const traduccionPaginaResult = yield call(deleteTraduccionPagina, action.payload)
    if (traduccionPaginaResult.ok) {
      putMessage(messageType.SUCCESS, 'Traducción página eliminada correctamente')
      yield put({
        type: actions.TRADUCCION_PAGINA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Traducción página')
      yield put({
        type: actions.TRADUCCION_PAGINA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Traducción página')
    yield all([
      put({
        type: actions.TRADUCCION_PAGINA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_TRADUCCION_PAGINA_BY_TIPO_ID(action) {
  try {
    const traduccionPaginaData = yield call(getTraduccionPaginanByTipoId, action.payload)
    if (traduccionPaginaData.ok) {
      yield put({
        type: actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_SUCCEEDED,
        payload: traduccionPaginaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar traduccion página')
      put({
        type: actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.TRADUCCIONES_PAGINA_LOAD_REQUESTED, GET_TRADUCCIONES_PAGINA),
    takeEvery(actions.TRADUCCION_PAGINA_INSERT_REQUESTED, INSERT_TRADUCCION_PAGINA),
    takeEvery(actions.TRADUCCION_PAGINA_UPDATE_REQUESTED, UPDATE_TRADUCCION_PAGINA),
    takeEvery(actions.TRADUCCION_PAGINA_DELETE_REQUESTED, DELETE_TRADUCCION_PAGINA),
    takeEvery(
      actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_REQUESTED,
      GET_TRADUCCION_PAGINA_BY_TIPO_ID,
    ),
  ])
}
